<div class="container-fluid" *ngIf="!isOrganizacion">
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a style="cursor: pointer;"  class="btn btn-primary"  (click)="volver()">
                  Volver
              </a>
            </div>
            <h3 class="page-title">Organizaciones | {{nom_ambito}} </h3>
            <hr class="text-dark">
        </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-5">
      <label for="busca" class="col-form-label">Bucar organización</label>
      <input
        class="form-control"
        type="text"
        id="buscar"
        placeholder="Buscar..."
        [(ngModel)]="searchTermOrg"
        (input)="buscar()"
        name="buscarOrganizacion">
    </div>
    <div class="col-md-7 d-flex align-items-end justify-content-end">
        <h4 class="mb-0">Total Cupos Seleccionados: <span class="badge bg-primary">{{ totalCuposSeleccionados }}</span></h4>
    </div>
  </div>

  <div class="col-12 mt-3 relacion-container">

    <div class="relacion-form-scrollable">
      <ng-container *ngFor="let org of filteredOrganizacion; let x = index; trackBy: trackByOrgId">
        <div class="row mb-2">
          <div class="col-md-10">
            <div class="form-check mb-2" style="padding-left: 2.5rem;">
              <input class="form-check-input"
                    type="checkbox"
                    id="org_{{org.id_organizacion}}" value="{{org.id_organizacion}}"
                    name="organizacion_{{org.id_organizacion}}"
                    [(ngModel)]="org.isChecked"
                    (change)="onCheckboxChange()"
                    style="font-size: 20px; border: 3px solid #313131;">
              <label class="form-check-label" for="org_{{org.id_organizacion}}"> {{org.organizacion}}   </label>
            </div>
          </div>
          <div class="col-md-2">
            <input class="form-control"
                      type="text"
                      id="cupo_{{org.id_organizacion}}"
                      placeholder="CUPO"
                      mask="00"
                      [(ngModel)]="org.cupoValue"
                      name="cupo_{{org.id_organizacion}}"
                      [disabled]="!org.isChecked"
                      (input)="calcularTotalCupos()" >
          </div>
        </div>
      </ng-container>
    </div>

    <div class="row mt-3">
      <div class="col-md-12 text-center">
        <a style="cursor: pointer;" class="btn btn-lg btn-primary" (click)="obtenerOrganizacionesSeleccionadas()">Aceptar</a>
      </div>
    </div>

  </div>


</div>

<app-seleccion-aspirantes *ngIf="isOrganizacion"
[year]="year"
[user]="user"
[id_ambito]="id_ambito"
[nom_ambito]="nom_ambito"
[cupos]="totalCuposSeleccionados"
[organizaciones]="organizacionesSeleccionadas"
(vuelve)="volver_organizacion($event)"
></app-seleccion-aspirantes>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
